<div *ngIf="currentStep as step" [class.has-close-button]="editMode">
  <button *ngIf="editMode" mat-icon-button class="close-button" (click)="onClose()" [attr.aria-label]="'buttons.close' | translate">
    <mat-icon>close</mat-icon>
  </button>
  <div class="survey-content-container">
    <div class="survey-progress-labels" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px;">
      <span class="steps-left-label">{{ 'survey.stepsLeft' | translate:{ count: stepsLeft } : stepsLeft + ' steps left' }}</span>
      <span class="minutes-remaining-label">{{ 'survey.minutesRemaining' | translate:{ count: minutesRemaining } : minutesRemaining + ' minutes remaining' }}</span>
      <button *ngIf="editMode" #menuTrigger mat-icon-button (click)="toggleStepsMenu($event)" [attr.aria-label]="'survey.navigateToStepAriaLabel' | translate">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    <mat-progress-bar mode="determinate" [value]="progressPercent"></mat-progress-bar>
    <div #stepsMenu class="steps-menu left-aligned" *ngIf="isStepsMenuOpen">
      <div class="steps-menu-content">
        <button mat-button class="step-menu-item" *ngFor="let navStep of navigableSteps"
                (click)="navigateToStepFromMenu(navStep._id, $event)"
                [class.active]="navStep._id === step._id">
          {{ getLangValue(navStep.title) }}
        </button>
      </div>
    </div>
    <div class="survey-step-content-area">
      <div class="survey-step-component">
        <ng-template #stepHost></ng-template>
      </div>
    </div>
  </div>
  <div class="survey-navigation">
    <button mat-raised-button (click)="onPrevious()" [disabled]="!step || stepIdToIndex[step._id] === 0">{{ 'buttons.previous' | translate:undefined:'Previous' }}</button>
    <button mat-raised-button *ngIf="editMode" (click)="onSubmit()" color="accent">{{ 'buttons.submitChanges' | translate:undefined:'Submit Changes' }}</button>
    <button mat-raised-button *ngIf="stepIdToIndex[step._id] < surveyModel.steps.length - 1" (click)="onNext()" color="primary" [disabled]="!isCurrentStepValid()">{{ 'buttons.next' | translate:undefined:'Next' }}</button>
    <button mat-raised-button *ngIf="stepIdToIndex[step._id] === surveyModel.steps.length - 1" (click)="onSubmit()" color="primary">{{ 'buttons.submit' | translate:undefined:'Submit' }}</button>
  </div>
</div>
